var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitching(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_942_20522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 21.25H6.74625C7.75115 21.2499 8.74122 21.0075 9.63251 20.5434C10.5238 20.0793 11.29 19.407 11.8663 18.5837L12.0875 18.2675M16.6625 11.7338L16.8837 11.4163C17.46 10.593 18.2262 9.92074 19.1175 9.4566C20.0088 8.99246 20.9988 8.75008 22.0038 8.75H26.25",
    stroke: "#00A657",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 5L26.25 8.75L22.5 12.5",
    stroke: "#00A657",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 8.75H6.74625C7.75115 8.75008 8.74122 8.99246 9.63251 9.4566C10.5238 9.92074 11.29 10.593 11.8663 11.4163L16.8837 18.5837C17.46 19.407 18.2262 20.0793 19.1175 20.5434C20.0088 21.0075 20.9988 21.2499 22.0038 21.25H26.25",
    stroke: "#00A657",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 25L26.25 21.25L22.5 17.5",
    stroke: "#00A657",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_942_20522"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitching);
export default __webpack_public_path__ + "static/media/switching.5fdd429aee35a48f71b0d775b8c044b1.svg";
export { ForwardRef as ReactComponent };